<!--
    描述：平台用户管理
    日期：2021/04/21
    作者：zwh

    edit by 王帅
-->
<template>
	<div class="w-table-layout w-table-page">
		<transition name="fade"
					mode="out-in">
			<!-- 列表 -->
			<div class="list-wrap w-table-content"
				 ref="tableContent"
				 key="list">
				<el-table :data="tableObj.tableData"
						  row-key="id"
						  v-loading="tableObj.loading"
						  ref="tableObj"
						  default-expand-all
						  :height="tableObj.tableH"
						  border
						  highlight-current-row>
					<el-table-column type="index"
									 align="center"
									 label="序号"
									 width="60"></el-table-column>
					<el-table-column prop="sname"
									 label="姓名"
									 header-align="center"
									 align="center"
									 show-overflow-tooltip
									 min-width="70"></el-table-column>
					<el-table-column prop="username"
									 label="用户名"
									 header-align="center"
									 align="center"
									 show-overflow-tooltip
									 min-width="70"></el-table-column>
					<el-table-column prop="phone"
									 label="手机号"
									 header-align="center"
									 align="center"
									 show-overflow-tooltip
									 min-width="70"></el-table-column>
					<el-table-column prop="tenantName"
									 label="所属单位"
									 header-align="center"
									 align="center"
									 show-overflow-tooltip
									 min-width="100"></el-table-column>
					<el-table-column prop="sex"
									 label="性别"
									 header-align="center"
									 align="center"
									 show-overflow-tooltip
									 min-width="50">
						<template slot-scope="scope">
							<div v-if="scope.row.sex">{{ parseInt(scope.row.sex) === 1 ? '男' : '女' }}</div>
							<div v-else></div>
						</template>
					</el-table-column>
					<el-table-column prop="age"
									 label="年龄"
									 header-align="center"
									 align="center"
									 show-overflow-tooltip
									 min-width="50"></el-table-column>
					<el-table-column v-if="roleType ===0"
									 prop="orChargeUser"
									 label="负责人"
									 show-overflow-tooltip
									 align="center"
									 min-width="50">
						<template slot-scope="scope">
							<span v-if="scope.row.orChargeUser">是</span>
							<span v-if="!scope.row.orChargeUser">否</span>
						</template>
					</el-table-column>
					<el-table-column prop="orEnable"
									 label="账号状态"
									 header-align="center"
									 align="center"
									 show-overflow-tooltip
									 min-width="50">
						<template slot-scope="scope">
							<el-switch v-show="!isMaintenance && roleType ===1"
									   v-model="scope.row.orEnable"
									   :active-value="1"
									   :inactive-value="0"
									   @change="orEnableChange($event, scope.row)"></el-switch>
							<span v-show="(isMaintenance || roleType ===0) && scope.row.orEnable === 0"
								  style="color: #ff0000">禁用</span>
							<span v-show="(isMaintenance || roleType ===0) && scope.row.orEnable === 1"
								  style="color: #69c80c">启用</span>
						</template>
					</el-table-column>
					<el-table-column label="操作"
									 align="center"
									 show-overflow-tooltip
									 width="150">
						<template slot-scope="scope">
							<el-button size="mini"
									   icon="el-icon-edit"
									   title="编辑"
									   type="text"
									   v-if="roleBtns.includes('platform_user_edit')"
									   @click="doClick(scope.row,'edit')"></el-button>
							<el-button size="mini"
									   icon="el-icon-search"
									   title="查看"
									   type="text"
									   v-if="roleBtns.includes('platform_user_view')"
									   @click="doClick(scope.row,'view')"></el-button>
							<el-button size="mini"
									   icon="el-icon-delete"
									   title="删除"
									   type="text"
									   v-if="roleBtns.includes('platform_user_delete') && !scope.row.orChargeUser"
									   @click="doClick(scope.row,'delete')"></el-button>
							<el-button size="mini"
									   icon="el-icon-link"
									   title="重置密码"
									   type="text"
									   v-if="roleBtns.includes('reset_password')"
									   @click="doClick(scope.row,'reset')"></el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</transition>

		<!-- 底部分页 -->
		<div class="w-table-footer">
			<el-pagination @size-change="handleSizeChange"
						   @current-change="handleCurrentChange"
						   :current-page="tableObj.currentPage"
						   :page-sizes="tableObj.pageList"
						   :page-size="tableObj.pageSize"
						   layout="total, sizes, prev, pager, next, jumper"
						   :total="tableObj.total">
			</el-pagination>
		</div>

		<!-- 新增、编辑等弹窗 -->
		<el-dialog :title="dialogObj.title"
				   center
				   :visible.sync="dialogObj.visible"
				   :width="dialogObj.width"
				   :close-on-click-modal="false">
			<!-- 弹窗组件 -->
			<userAddDialog ref="addUser"
						   :transObj="transObj"
						   v-if="dialogObj.visible"
						   @handle-success="handleSuccess"></userAddDialog>
			<!-- footer 组件 -->
			<div slot="footer"
				 class="dialog-footer text-center"
				 v-if="dialogObj.mode !== 'view'">
				<el-button size="small"
						   @click="dialogObj.visible = false">取 消</el-button>
				<el-button type="primary"
						   size="small"
						   :loading="btnLoading"
						   @click="doSave('addUser')">确 定</el-button>
			</div>
		</el-dialog>

		<!-- 新增、编辑等弹窗 -->
		<el-dialog :title="importUserDialog.title"
				   :visible.sync="importUserDialog.visible"
				   :width="importUserDialog.width"
				   center
				   :close-on-click-modal="false"
				   @closed="handleClose('importUser')">
			<!-- 弹窗组件 -->
			<userImportDialog v-if="importUserDialog.visible"
							  ref="userImportDialog"
							  :transObj="transObj"
							  @handle-success="importUserSuccess"></userImportDialog>
			<!-- footer 组件 -->
			<div slot="footer"
				 class="dialog-footer text-center"
				 v-if="importUserDialog.mode !== 'view'">
				<el-button size="small"
						   @click="importUserDialog.visible = false">取 消</el-button>
				<el-button type="primary"
						   size="small"
						   :loading="btnLoading"
						   @click="doSave('importUser')">保 存</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import {
	getPlatformUserPageList,
	updateUserOrEnable,
	removeById,
	getUserPageList,
	resetPassword,
} from 'api/system/user.js'
import userAddDialog from './user_add_dialog'
import userImportDialog from './user_import_dialog'
export default {
	components: { userAddDialog, userImportDialog },
	props: {
		searchParams: {
			type: Object,
			default: () => {
				return {}
			},
		},
	},
	data() {
		return {
			btnLoading: false,
			//搜索对象
			searchObj: {
				sname: '',
			},
			tableObj: {
				loading: false,
				tableH: 400,
				tableData: [],
				currentPage: 1,
				pageSize: 10,
				total: 0,
				pageList: [10, 20, 50, 100], // 显示条数数组
			},
			//弹框对象
			dialogObj: {
				title: '',
				visible: false,
				width: '500px',
				mode: 'add',
			},
			//子组件传递对象
			transObj: {
				id: '',
				mode: '',
			},
			//导入人员弹框对象
			importUserDialog: {
				title: '',
				visible: false,
				width: '550px',
				mode: 'add',
			},
		}
	},
	created() {
		//获取分页列表
		this.getTablePageList()
	},
	mounted() {
		this.$nextTick(() => {
			setTimeout(() => {
				this.tableObj.tableH = this.$refs.tableContent.offsetHeight
			}, 100)
		})
	},
	// 进入缓存页面触发
	activated() {
		this.$nextTick(() => {
			setTimeout(() => {
				this.tableObj.tableH = this.$refs.tableContent.offsetHeight
			}, 100)
		})
	},
	methods: {
		//按钮点击事件
		doClick(obj, type) {
			let params = {
				row: obj,
				type: type,
			}
			// 删除单独处理
			if (type === 'delete') {
				this.delete(obj)
			} else if (type === 'reset') {
				this.reset(obj)
			} else {
				this.$emit('handleTool', params)
			}
		},
		//搜索
		searchPageList(obj) {
			this.searchObj = obj
			this.tableObj.currentPage = 1
			this.getTablePageList()
		},
		//获取分页列表
		getTablePageList(search) {
			let that = this
			this.tableObj.currentPage = search ? 1 : this.tableObj.currentPage
			let param = Object.assign({}, this.searchParams)
			param.current = this.tableObj.currentPage
			param.size = this.tableObj.pageSize
			getUserPageList(param)
				.then((res) => {
					if (res.operationCode == 1) {
						that.tableObj.tableData = res.data.records
						that.tableObj.total = parseInt(res.data.total)
					}
				})
				.catch((err) => {})
		},
		//成功回调处理
		handleSuccess() {
			this.getTablePageList()
			this.dialogObj.visible = false
		},
		//是否启用
		orEnableChange(val, row) {
			this.$confirm(
				'确认' + (val == 1 ? '启用' : '禁用') + '吗?',
				'提示',
				{
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
				}
			)
				.then(() => {
					let param = {
						id: row.id,
						orEnable: val,
					}
					updateUserOrEnable(param).then((res) => {
						if (
							typeof res != 'undefined' &&
							res.operationCode == 1
						) {
							this.$message({
								message: (val == 1 ? '启用' : '禁用') + '成功',
								type: 'success',
							})
							this.getTablePageList()
						} else {
							if (val == 0) row.orEnable = 1
							else row.orEnable = 0
						}
					})
				})
				.catch((action) => {
					if (val == 0) row.orEnable = 1
					else row.orEnable = 0
				})
		},
		//重置密码
		reset(row) {
			this.$confirm('确定重置该用户密码？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			}).then(() => {
				let param = {}
				param.id = row.id
				resetPassword(param).then((res) => {
					if (res.operationCode === 1) {
						this.$message.success('重置密码成功！')
					} else {
						this.$message.error(res.msg)
					}
				})
			})
		},
		//删除
		delete(row) {
			this.$confirm('确认删除该用户', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			}).then(() => {
				let param = {}
				param.id = row.id
				removeById(param).then((res) => {
					if (res.operationCode === 1) {
						this.$message.success('删除成功！')
						this.getTablePageList('1')
					} else {
						this.$message.error(res.msg)
					}
				})
			})
		},
		//保存
		doSave(type) {
			if (type == 'importUser') {
				//导入用户
				this.$refs.userImportDialog.doSave()
			} else if (type == 'addUser') this.$refs.addUser.doSave() //新增用户
		},
		//导入按钮点击
		importBtnClick() {
			this.importUserDialog.title = '导入用户'
			this.importUserDialog.visible = true
			this.importUserDialog.mode = 'add'
		},
		//导入人员成功回调事件
		importUserSuccess() {
			this.importUserDialog.visible = false
			this.getTablePageList()
		},
		//关闭
		handleClose(type) {
			if (type == 'importUser') {
				this.importUserDialog.visible = false
			}
		},

		// 切换显示条数
		handleSizeChange(val) {
			this.tableObj.pageSize = val
			this.getTablePageList()
		},

		// 切换当前页码
		handleCurrentChange(cur) {
			this.tableObj.currentPage = cur
			this.getTablePageList()
		},
	},
	computed: {
		...mapState('app', { clientSize: (state) => state.clientSize }),
		...mapState('menu', {
			roleBtns: (state) => state.roleBtns,
		}),
		...mapState('user', {
			userInfo: (state) => state.userInfo,
			roleType: (state) => state.userInfo.roleType, // 1 是超级管理员  0 是普通
			isMaintenance: (state) => state.isMaintenance, // 运维角色
		}),
	},
	watch: {
		clientSize(val) {
			this.tableObj.tableH = this.$refs.tableContent.offsetHeight
		},
	},
}
</script>

<style scoped>
</style>